const LOG_PREFIX = '[Assist checkout debug]';

export const logAssistCheckoutDebug = (step, payload = {}) => {
  console.log(LOG_PREFIX, step, payload);
};
